import {
  settingsOfficeFetchActionHandler,
  settingsOfficeByIdFetchActionHandler,
  settingsOfficeCreateActionHandler,
  settingsOfficeUpdateActionHandler,
  settingsOfficeDeleteActionHandler,
} from "./settings/settings-office";

import {
  fetchUserManual,
  updateUserManual,
  deleteUserManual,
} from "./settings/userManual/user-manual";

import { deletePositionsInfo } from "./positionsInfo/positions-info-action";

const HRMActionsHandlers = {
  settingsOfficeFetchActionHandler,
  settingsOfficeByIdFetchActionHandler,
  settingsOfficeCreateActionHandler,
  settingsOfficeUpdateActionHandler,
  settingsOfficeDeleteActionHandler,

  // user manual

  fetchUserManual,
  updateUserManual,
  deleteUserManual,

  // positions information

  deletePositionsInfo,
};

export default HRMActionsHandlers;
